import {Component, Inject} from '@angular/core';
import {DOCUMENT} from '@angular/platform-browser';
import {Router, ActivatedRoute, UrlSegment} from '@angular/router';
import {BaseService} from './service/BaseService'
//import { HttpClient } from '@angular/common/http';
//import {Headers, Response,RequestOptions,Jsonp,ResponseContentType} from '@angular/http';
import {TabService} from "./components/Multitab/tab.service";
import {Tab} from "./components/Multitab/tab.model";
import {PassService} from './service/PassService';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
})
export class AppComponent {
    base: any;
    service: any;
    javapath: any;
    // title = 'app';
    // results = '';
     tabs = new Array<Tab>();
    selectedTab: number;
    constructor( @Inject(DOCUMENT) document: any, private baseservice: BaseService, private tabService: TabService, public passer: PassService) {
        console.log(document.location.href);
        this.base = document.location.href

        this.javapath = [{"key": "esealstore.com", "value": "esealstore"}, {"key": "portal.esealstore.com", "value": "esealstore"}, {"key": "test.esealstore.com", "value": "esealstore"},
        {"key": "portal1.esealstore.com", "value": "esealstore"}];
    }
    ngOnInit() {
        this.basesplitter();
            this.tabService.tabSub.subscribe(tabs => {
            console.log("this.tabs!!",this.tabs);
            this.tabs = tabs;
            this.selectedTab = tabs.findIndex(tab => tab.active);
            console.log("this.selectedTab..",this.selectedTab);
        });
    }
    basesplitter() {
        let stringToSplit = this.base
        let x = stringToSplit.split("//");
        console.log(x)
        let y = x[1].split("/");
        console.log(y)
        this.service = y[1];
        //        if (this.service !        = "") {
        //            this.baseservice.url = "/" + this.service         + '/rs'
        //                }
        //                else {
        //            this.baseservice.url = "/ESealStor        e_Java"
        //            //                    + '/rs'
        //        }

        var jpath = this.javapath.find(path => path.key == y[0]);
        console.log("jpath..", jpath);
        setTimeout(() => {
            if (jpath) {
                this.baseservice.url = "/" + jpath.value + "/rs"
            } else if (this.service != "") {
                this.baseservice.url = "/" + this.service + "/rs"
            } else {
                this.baseservice.url = "/ESealStore_Java/rs"
            }
            console.log(this.baseservice.url)
        }, 2000);

        //console.log(this.baseservice.url)
    }
    /*
    onclick(){
    //    let headers1 = new Headers({ 'Content-Type': 'application/json' });
    //   let options = new RequestOptions({ headers: headers1 });
            //this.http.post('http://localhost:8084/EzeeShipping_Java/userlogin', JSON.stringify({"username":"vikky@sample.net","password":"welcome"}),{headers: options});
            console.log("clicked");
            this.http.get('http://localhost:8084/EzeeShipping_Java/users').subscribe(data => {
           // this.http.post(this.customersUrl, JSON.stringify(customer), {headers: this.headers})
          console.log(data);
        });
        
    }
    */
    //user:Object;
    //	  
    //	onNavigate(userdata:Object) {
    //		this.user = userdata;
    //		console.log("ghjgghhh"+this.user);

    //}
        tabChanged(event) {
        console.log("tab changed");
    }

    removeTab(index: number): void {
        this.tabService.removeTab(index);
    }
}


// WEBPACK FOOTER //
// D:/ESealStore_AJS/src/app/app.component.ts